import { render, staticRenderFns } from "./modalDetailApprovedMember.vue?vue&type=template&id=211fe454&scoped=true"
import script from "./modalDetailApprovedMember.vue?vue&type=script&lang=js"
export * from "./modalDetailApprovedMember.vue?vue&type=script&lang=js"
import style0 from "./modalDetailApprovedMember.vue?vue&type=style&index=0&id=211fe454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211fe454",
  null
  
)

export default component.exports